import { render, staticRenderFns } from "./alarmSetting-order.vue?vue&type=template&id=5233523e"
import script from "./alarmSetting-order.vue?vue&type=script&lang=ts"
export * from "./alarmSetting-order.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports